import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { TypeMagasin } from "../../Models/Magasin/MagasinModels";
import { EnseigneService } from "./EnseigneService";
import { errorService } from "../Error/ErrorService";
import { DataTypeMagasinLogo } from "../../Models/Admin/AdminModels";
import { FichierService } from "../Demande/FichierService";

export function TypeMagasinService(){
    return{
        async getTypesMagasins(token:string){
            try {
                const response = await axios.get(`${URLAPI+'typesMagasin'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let typeMagasin:TypeMagasin[]=[]
                //obtention des enseignes pour assigner aux types de magasin
                for(const element of data){
                  typeMagasin.push({
                      id: element['id'],
                      type: element['type'],
                      edited: false,
                      actif:true,
                      enseigne:{"@id":element['enseigne'], id:0, nom:'', fichiers:[]},
                      magasins:element['magasins'],
                      messages:element['messages'],
                      fichiers:element['fichiers']
                  })
                }

                const enseignes = await EnseigneService().getEnseignes(token);
                for(const type of typeMagasin){
                    const result = enseignes.find(ens=>ens["@id"]===type.enseigne?.["@id"]);
                    if(result)type.enseigne=result;
                }
        
                return typeMagasin;
              } catch (error) {
                  errorService().handleError('Erreur lors du getPacksForEditAddMagasinsAdmin', error);
                  return []
              }
        },

        async getTypeMagasin(idTypeMagasin:number, token:string):Promise<TypeMagasin>{
            try {
                const response = await axios.get(`${URLAPI+'typeMagasin/'+idTypeMagasin}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                let typeMagasin:TypeMagasin = {
                    id:data[0]['id'],
                    type:data[0]['type'],
                    messages:undefined,
                    enseigne:data[0]['enseigne'],
                    magasins:data[0]['magasins'],
                    edited: false,
                    actif:true,
                    fichiers:data[0]['fichiers']
                }
                return typeMagasin;
            } catch (error) {
                let typeMagasin:TypeMagasin = {
                    id:0,
                    type:'',
                    messages:undefined,
                    enseigne:undefined,//temporaire
                    magasins:[],
                    edited: false,
                    actif:false,
                    fichiers:[]
                }
                return typeMagasin;
            }   
        },

        async getTypeMagasinFromUrlToPromiseToMagasin(url:string, token:string):Promise<TypeMagasin>{
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                let typeMagasin:TypeMagasin = {
                    id:data[0]['id'],
                    type:data[0]['type'],
                    messages:undefined,
                    enseigne:data[0]['enseigne'] ? await EnseigneService().getEnseigneFromUrlToPromiseToTypeMagasin(data[0]['enseigne'], token) : undefined,//temporaire
                    magasins:data[0]['magasins'],
                    edited: false,
                    actif:true,
                    fichiers:data[0]['fichiers']
                }
                return typeMagasin;
            } catch (error) {
                let typeMagasin:TypeMagasin = {
                    id:0,
                    type:'',
                    messages:undefined,
                    enseigne:undefined,//temporaire
                    magasins:[],
                    edited: false,
                    actif:false,
                    fichiers:[]
                }
                return typeMagasin;
            }   
        },

        async getTypeMagasinsFromUrlToPromiseToEnseigne(urls:string[], token:string):Promise<TypeMagasin[]>{
                let typeMagasins:TypeMagasin[]=[]
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
                        let typeMagasin:TypeMagasin = {
                            id:data[0]['id'],
                            type:data[0]['type'],
                            messages:undefined,
                            enseigne:undefined,//temporaire
                            magasins:data[0]['magasins'],
                            edited: false,
                            actif:true,
                            fichiers:data[0]['fichiers']
                        }
                        typeMagasins.push(typeMagasin);

                    } catch (error) {
                        errorService().handleError('Erreur lors du getTypeMagasinsFromUrlToPromiseToEnseigne', error)
                        return [];
                    }
                }
                return typeMagasins;
        },

        async getTypeMagasinsFromUrlToPromiseToEnseigneAdmin(urls:string[], token:string):Promise<TypeMagasin[]>{
            const controller = new AbortController();
            let typeMagasins:TypeMagasin[]=[]
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                            signal:controller.signal
                        });
    
                        const data = response.data['hydra:member'];
                        let typeMagasin:TypeMagasin = {
                            id:data[0]['id'],
                            type:data[0]['type'],
                            messages:undefined,
                            enseigne:undefined,//temporaire
                            magasins:data[0]['magasins'],
                            edited: false,
                            actif:true,
                            fichiers:data[0]['fichiers']
                        }
                        typeMagasins.push(typeMagasin);
                    } catch (error) {
                        controller.abort();
                        errorService().handleError('Erreur lors du getTypeMagasinsFromUrlToPromiseToEnseigne', error)
                        return [];
                    }
                }
            }
            controller.abort();
            return typeMagasins;
        },

        async getTypeMagasinsForEditAddMagasinAdmin(token:string){
            try {
              const response = await axios.get(`${URLAPI+'typesMagasin'}`, {
                  headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type":"application/ld+json"
                  },
              });
              const data = response.data['hydra:member'];
              let typeMagasin:TypeMagasin[]=[]
              //obtention des enseignes pour assigner aux types de magasin
              const enseignes = await EnseigneService().getEnseignes(token)
              for(const element of data){
                // const [enseigne] = await Promise.all([
                //     EnseigneService().getEnseigneFromUrlToPromiseToTypeMagasin(element['enseigne'], token),
                // ]);
                typeMagasin.push({
                    id: element['id'],
                    type: element['type'],
                    edited: false,
                    actif:true,
                    enseigne:enseignes.find(enseigneResult=>enseigneResult["@id"]===element['enseigne']),
                    magasins:element['magasins'],
                    fichiers:element['fichiers']
                })
              }
      
              return typeMagasin;
            } catch (error) {
                errorService().handleError('Erreur lors du getPacksForEditAddMagasinsAdmin', error);
                return []
            }
        },

        async postTypeMagasin(typeNom:string, idEnseigne:number, token:string){
            const postObjectTypeMagasin = {
                "type": typeNom,
                "magasins": [],
                "enseigne": idEnseigne
            }
            const responsePOSTTypeMagasin = await axios.post(
                `${URLAPI+'typeMagasin'}`,
                postObjectTypeMagasin,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return {status:responsePOSTTypeMagasin.status, idResult:responsePOSTTypeMagasin.data['id']}
        },

        async patchTypeMagasin(type:TypeMagasin, token:string){
            const patchObjectTypeMagasin = {
                "type": type.type,
            }
            const responsePatchTypeMagasin = await axios.patch(
                `${URLAPI+'typeMagasin/'+type.id}`,
                patchObjectTypeMagasin,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return responsePatchTypeMagasin.status;
        },

        async postTypeMagasinLogo(dataType:DataTypeMagasinLogo, token:string){
            let status = 400;
            if(dataType.fichiersTypeMag.length>0){
                status = await FichierService().deleteFichier(dataType.fichiersTypeMag[0].id, token);
            }
            if(dataType.fichierLogo){
                status = (await FichierService().postFichierTypeMagasin(dataType.fichierLogo, dataType.id,token)).status;
            }

            return status;

        },

        async deleteTypeMagasin(idType:number, token:string){
            //On s'assure de la suppression de l'idntifiant lié au magasin avant de supprimer le magasin
            const responseMagasin = await axios.delete(
                `${URLAPI}typeMagasin/${idType}`,
                {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    },
                }
            );
            return responseMagasin.status;
        }
    }
}